import Vue from 'vue';
import Router from 'vue-router';

import Index from '@/components/Index';
import Character from '@/components/Character';
import Art from '@/components/Art';
import EventView from '@/components/Event';
import PastEventsView from '@/components/PastEvents';
import Privacy from '@/components/Privacy';
import NotFound from '@/components/NotFound';

Vue.use(Router);
export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    // /char redirects to /character
    {
      path: '/char',
      name: 'Character',
      redirect: '/character'
    },
    {
      path: '/character',
      name: 'Character',
      component: Character
    },
    {
      path: '/art',
      name: 'Art',
      component: Art
    },
    {
      path: '/event/next',
      name: 'NextEvent',
      redirect: '/'
    },
    {
      path: '/event/past',
      name: 'PastEvents',
      component: PastEventsView
    },
    {
      path: '/event/:event_id',
      name: 'Event',
      component: EventView
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: NotFound
    },
    // Wenn keine der oberen Routen ausgelöst wurde => Nicht gefunden
    {
      path: '*',
      name: 'notFound',
      redirect: '/not-found'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js